<template>
    <Toast/>
    <section class=" text-white font-montserrat">
        <!-- Hero -->
        <div class="text-center px-3 py-14 bg-gradient-to-br from-slate-500 to-slate-700 mb-12" style="background-image: url('/landingpages/dj-set1/header_bg.png'); background-size: cover; background-position: center;">
            <div class="backdrop-brightness-50 backdrop-blur p-7 rounded-3xl  lg:max-w-4xl mx-auto">
                <h2 class="text-5xl mb-8">Bereit für deine nächste Party?</h2>
                <p class="text-2xl mb-6">Mit diesem DJ-Set wird dein Event unvergesslich!</p>
                <p class="text-l mb-6">kein Stress | satter Sound | Club-Feeling</p>
                <div @click="navigateTo('#request-form')" class="bg-blue-900 text-white font-bold py-2 px-8 rounded-xl shadow hover:bg-neutral-800 transition text-2xl w-fit m-auto cursor-pointer">Jetzt anfragen</div>
            </div>
        </div>
        
        
        <div class="max-w-4xl mx-auto px-6 text-center mb-12">
            <h2 class="text-2xl mb-3">Wer will sich schon bei seiner Party um die Technik kümmern?</h2>
            <p class="text-xl  mb-4">
                Niemand! Deshalb haben wir hier ein Set geschnürt bei dem du dich
                um nichts kümmern musst. Einfach bei uns Buchen, wir kommen zu dir, bauen alles auf und es kann direkt losgehen.
            </p>
        </div>
        
        
        <!-- Zielgruppe -->
        <div class="w-full flex justify-center items-center mb-10">
            <div class="bg-neutral-700 py-6 px-4 text-center rounded-xl mx-4 max-w-4xl">
                <h2 class="text-2xl font-bold mb-2 text-white">🎯 Ideal für:</h2>
                <p class="text-lg ">
                    Hochzeiten · Geburtstage · DJ-Gigs · Firmenfeiern
                </p>
            </div>
        </div>
        <div class="text-center mb-12">
            <div @click="navigateTo('#request-form')" class="bg-[#E39737] text-black text-xl py-2 px-8 rounded-2xl shadow-xl hover:bg-[#d6882f] transition cursor-pointer w-fit m-auto">
                Unverbindlich anfragen
            </div>
        </div>
        
        <div class="text-center mb-6">
            <h2 class="text-xl font-bold mb-4">So sieht das Set im Einsatz aus</h2>
            <img src="/landingpages/dj-set1/DJ_Set_1_4.JPG" alt="DJ Set" class="w-full h-auto shadow-lg mx-auto max-w-[90%] rounded-xl lg:max-w-4xl">
        </div>
        
        <!--Vorteile-->
        <div class="max-w-4xl mx-auto py-12 px-6">
            <h2 class="text-2xl font-bold mb-4">✨ Deine Vorteile:</h2>
            <ul class="space-y-3 text-lg text-neutral-300 list-disc list-inside">
                <li>Club-Feeling: Mit sattem Bass und Moving-Heads</li>
                <li>Kein Technik-Stress - du konzentrierst dich aufs Feiern</li>
                <li>Professionelles & zuverlässiges Equipment</li>
                <li>Aufbau & Einrichtung durch uns</li>
                <li>Sofort startklar: Plug & Play</li>
                <li>Inkl. einfacher Lichtsteuerung - auch soundgesteuert</li>
                <li>Für bis zu ca. 150 Personen</li>
            </ul>
        </div>
        
        
        <div class="flex justify-center">
            <video class="w-full max-w-[90%] rounded-xl shadow-lg lg:max-h-screen" playsinline controls poster="/landingpages/dj-set1/video_poster.png">
                <source src="/landingpages/dj-set1/Video.mp4" type="video/mp4" />
                Dein Browser unterstützt keine Videos.
            </video>
        </div>
        
        <!-- Features -->
        <div class="max-w-4xl mx-auto mt-12 px-6 mb-6">
            <div class="mb-8">
                <h2 class="text-2xl font-bold mb-4">✅ Das ist enthalten:</h2>
                <ul class="space-y-2 text-lg text-neutral-300">
                    <li>🎚️ 2x Topteile passiv mit je 600W</li>
                    <li>🔊 2x Subwoofer passiv mit je 1200W</li>
                    <li>🎛️ 4x Moving Head inkl. Steuerung</li>
                    <li>🌫️ Nebelmaschine Smoke-Factory Hazer</li>
                    <li>🧰 Inkl. Kabel, Stative & Verstärker</li>
                    <li>🛠️ Lieferung & Aufbau inkludiert</li>
                </ul>
            </div>
        </div>
        
        <!-- CTA -->
        <div class="text-center mb-12 max-w-4xl mx-auto" id="request-form">
            <div class="text-lg font-semibold text-center px-3">Pauschalangebot ab 1.090€ (inkl. Lieferung & Aufbau)</div>
            <div class="text-lg text-center mb-6 px-3">alles drin, keine versteckten Kosten.</div>
            <form @submit.prevent="submitRequest" v-if="!loading">
                <div>
                    <InputText
                    required
                    v-model="name"
                    type="text"
                    placeholder="Dein Name"
                    class="w-full max-w-xs mb-4"/>
                </div>
                <div>
                    <InputText
                    required
                    v-model="email"
                    type="email"
                    placeholder="Deine E-Mail"
                    class="w-full max-w-xs mb-4"
                    />
                </div>
                <div class="w-full max-w-xs mb-4 mx-auto">
                    <DatePicker class="w-full" v-model="date" :default-value="new Date()" aria-required required date-format="dd.mm.yy" placeholder="Datum"></DatePicker>
                </div>
                <div>
                    <Textarea class="w-full max-w-xs mb-4" v-model="description" placeholder="Sonstige Infos"></Textarea>
                </div>
                <div>
                    <div class="flex items-center gap-2 w-full max-w-xs mb-4 mx-auto text-left text-sm">
                        <Checkbox required inputId="aggreeTerms" name="AGBs" value="0" />
                        <label for="aggreeTerms">Ich habe die <a class="underline" href="/agb">AGB</a> gelesen und akzeptiere sie. Mit dem Absenden stimme ich der Verarbeitung meiner Daten gemäß der <a class="underline" href="/privacy">Datenschutzerklärung</a> zu.</label>
                    </div>
                </div>
                <div>
                    <div class="flex items-center gap-2 w-full max-w-xs mb-4 mx-auto text-left text-sm">
                        <Checkbox v-model="subscribeNewsletter" inputId="subscribeNewsletter" name="Newsletter" value="0" binary/>
                        <label for="subscribeNewsletter">Für unseren Newsletter anmelden? {{ subscribeNewsletter }}</label>
                    </div>
                </div>
                <div>
                    <button type="submit" to="/kontakt" class="bg-[#E39737] text-black text-xl py-2 px-8 rounded-2xl shadow-xl hover:bg-[#d6882f] transition cursor-pointer w-fit m-auto">
                        Unverbindlich anfragen
                    </button>
                </div>
            </form>
            <div v-if="loading" class="mt-20">
                <div class="flex justify-center items-center">
                    <ProgressSpinner style="width: 70px; height: 70px;" strokeWidth="4" />
                </div>
                <div class="text-lg mt-4">
                    Deine Anfrage wird bearbeitet...
                </div>
            </div>
            
            <div class="text-lg text-center mt-6 max-w-2xl mx-auto px-4">Falls du eine kleinere oder größere Anlage suchst, schreibs einfach ins Feld "Sonstige Infos" oder schau auf unserer Website <a class="underline" href="/" @click="useTrackEvent('send_djset1_moved_to_website');console.log('navigated to home');">www.mody.at</a> vorbei.</div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useReCaptcha } from 'vue-recaptcha-v3';
import { useModyApi } from '~/middelware/ModyApi';
import type { RequestData } from '~/store/userdata';

const toast = useToast();
const api = useModyApi();
const loading = ref(false);
const name = ref("");
const email = ref("");
const description = ref("");
const subscribeNewsletter = ref(false);
const date = ref(new Date());
const cookieControl = useCookieControl()

const {proxy} = useScriptMetaPixel({
    id: '1261825978785243',
    
})

onMounted(()=>{
    enableMetaPixel()
})

watch(cookieControl.cookiesEnabledIds, (newValue) => {
    enableMetaPixel()
})

function enableMetaPixel(){
    if(cookieControl.cookiesEnabledIds.value?.includes("meta-pixel")){
        console.log("Meta Pixel enabled")
        proxy.fbq("consent", "grant");
        proxy.fbq("track", "PageView"); // PageView event tracken
    }
    else{
        console.log("Meta Pixel disabled")
        proxy.fbq("consent", "revoke");
    }
}

useHead({
    meta: [
    {
        name: 'description',
        content: 'Miete ein komplettes DJ-Set mit Ton- und Lichttechnik – inklusive Aufbau, Lieferung und professionellem Sound. Ideal für Hochzeiten, Geburtstage, Firmenfeiern uvm.'
    }
    ]
});

const recaptchaInstance = useReCaptcha();
const recaptcha = async () => {
    // optional you can await for the reCaptcha load
    await recaptchaInstance?.recaptchaLoaded();
    
    // get the token, a custom action could be added as argument to the method
    return recaptchaInstance?.executeRecaptcha('yourActionHere');
};

async function submitRequest() {
    // Hier kannst du die Logik für das Absenden des Formulars implementieren
    // Zum Beispiel eine API-Anfrage, um die Daten zu speichern oder zu versenden
    console.log("Formular abgesendet", name.value, email.value, date.value);
    
    let token
    try {
        token = await recaptcha()
    }
    catch (e) {
        console.log(e)
    }
    
    if(!token) {
        toast.add({detail:"Es ist leider etwas schief gelaufen!",severity:"error",life:5000})
        return
    }
    loading.value = true
    const requestData = ref<RequestData>({
        name: name.value,
        email: email.value,
        date_from: date.value,
        date_to: date.value,
        company_name: '',
        address: '',
        city: '',
        description: description.value,
        eventDays: 1,
        telephone: '',
        subscribeNewsletter: subscribeNewsletter.value,
    })
    
    let product = new Product()
    try {
        product = await api.getProduct(1445)
    } catch (error) {
        toast.add({detail:"Es ist leider etwas schief gelaufen!",severity:"error",life:5000})
        useTrackEvent("send_djset1_request_failure")
        return 
    }
    console.log("Product",product)
    
    const cart = new Cart()
    cart.products = [
    {
        count: 1,
        product: product,
        factor: 1,
        price: 1090,
        sectionName: '',
        comment: '',
        editSectionName: false
    }    
    ]
    
    const success = await api.sendRequest(requestData,cart)
    setTimeout(()=>{
        loading.value = false
        if(success){
            toast.add({detail:"Anfrage wurde gesendet!",severity:"success",life:5000})
            useTrackEvent("send_djset1_request_success")
            navigateTo('/')
        }
        else{
            toast.add({detail:"Es ist leider etwas schief gelaufen!",severity:"error",life:5000})
            useTrackEvent("send_djset1_request_failure")
        }
    },2000)
}

</script>

